import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { laVistaConfig } from "./data";

export default function LaVistaPage() {
  return <CityPageTemplate config={laVistaConfig} />;
}